import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=f9cc3d2a"
import script from "@/views/Webshop/OrderOverview/OrderOverview.ts?vue&type=script&lang=ts&external"
export * from "@/views/Webshop/OrderOverview/OrderOverview.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Webshop/OrderOverview/order-overview.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports